export const MANAGE_BOOKINGS_APIS = {
  instalment_history: "payments/creator/customer/installments/history",
};
